import { getTierName } from "./subscription";

export const normalizeAuthResponse = (authResponse) => {
    const {
        access_token,
        refresh_token,
        expires_in,
        refresh_expires_in,
        user,
        workspace,
        credits,
        token_type,
        csv_export_enabled,
    } = authResponse;

    if (!user) return null;

    const normalizedPlan = getTierName(credits, user.plan);

    return {
        token: access_token,
        refreshToken: refresh_token,
        expiresIn: expires_in,
        refreshExpiresIn: refresh_expires_in,
        tokenType: token_type,
        user: {
            ...user,
            role: user.role || (user.is_admin ? "admin" : "user"),
            name: user.full_name || user.name || user.email,
            plan: normalizedPlan,
        },
        workspace,
        credits: credits || null,
        csvExportEnabled:
            csv_export_enabled === undefined
                ? undefined
                : csv_export_enabled === true,
    };
};
